// extracted by mini-css-extract-plugin
module.exports = {"card":"LargeCard_card__10_2x","img":"LargeCard_img__2MZ7y","text":"LargeCard_text__35U8-"};